module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 85
// module chunks = 0